import React from 'react';
import { ItemNameProps } from '@v2/pages/machines/common/types/props';
import { Text, View } from 'react-native';
import { Element, scale } from '@components/frame';
import { isPhone, machineStatusColorName } from '@helpers';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

interface Props extends ItemNameProps {}

const ItemName = React.memo(
  ({ shortName, C, selected, isOperated, status, isProcessingPI, loading, displayTime, hasNoDataInPeriod }: Props) => (
    <View style={{ flexDirection: 'row', alignContent: 'center', alignItems: 'center', marginTop: scale(-2), paddingRight: scale(isPhone ? 35 : 0) }}>
      {displayTime && (
        <View
          style={[
            {
              width: scale(10),
              height: scale(10),
              borderRadius: scale(10),
              backgroundColor: hasNoDataInPeriod ? C('Label/Light/Quaternary') : C(machineStatusColorName[status]),
              opacity: isProcessingPI || loading ? 0 : 1,
            },
          ]}
        />
      )}
      <Text
        style={[{ marginLeft: scale(5.5), color: C(selected ? 'Label/Light/AlwaysLight Primary' : 'Label / Light / Primary') }, font.Headline]}
        numberOfLines={1}
      >
        {shortName}
      </Text>
      {isOperated && (
        <Element
          {...{
            config: {
              top: 5,
              right: 2,
            },
          }}
        >
          {selected ? (
            <Svg icon="operated" key="operatedSelected" color={'Label/Light/AlwaysLight Secondary'} width={scale(12)} height={scale(12)} />
          ) : (
            <Svg icon="operated" key="operatedNotSelected" color={'Label/Light/Tertiary'} width={scale(12)} height={scale(12)} />
          )}
        </Element>
      )}
    </View>
  ),
  (prev, next) =>
    prev.status === next.status &&
    prev.shortName === next.shortName &&
    prev.C.scheme === next.C.scheme &&
    prev.selected === next.selected &&
    prev.isProcessingPI === next.isProcessingPI &&
    prev.loading === next.loading &&
    prev.displayTime === next.displayTime &&
    prev.isOperated === next.isOperated &&
    prev.hasNoDataInPeriod === next.hasNoDataInPeriod
);

export { ItemName };
